import React from 'react';
import { setCurrentProductId } from '../../redux/buyCourse/buyCourse.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Config from '../../config/Config';
import Zoom from '../utils/animations/zoom';

const RecommendedProductCard = ({
	product_tags,
	offer_price,
	original_price,
	product_icon_url,
	product_tag_line,
	product_id,
	product_name,
	history,
	setCurrentProductId,
	isInternational,
	offer_price_usd,
	original_price_usd,
	product_name_slug,
}) => {
	const originalPrice = isInternational ? original_price_usd : original_price;
	const offerPrice = isInternational ? offer_price_usd : offer_price;
	const currency = isInternational ? '$ ' : '₹ ';
	const learnMoreClick = () => {
		setCurrentProductId(product_id);
		history.push('/purchase');
	};

	let offer_price_display = currency + offerPrice;
	let original_price_display = currency + originalPrice;
	let offer_percent = '';
	if (offerPrice === originalPrice) {
		offer_percent = '';
		original_price_display = '';
	} else {
		offer_percent =
			Math.round(((originalPrice - offerPrice) / originalPrice) * 100) + '% off';
	}

	return (
		<Zoom>
			<Card className="RecommendedCourseList" style={{ margin: '18px' }}>
				<Card.Header>
					<div className="RecommendedCourseTitle">
						{product_name} - {product_tag_line}
					</div>
				</Card.Header>
				<Card.Body>
					<div className="row">
						<img
							className="col-xs-12 col-md-6 col-sm-6 col-lg-6 course-list-img"
							src={product_icon_url}
							alt="courseimg"
						/>

						<div className="col-xs-12 col-md-6 col-sm-6 col-lg-6">
							<div className="RecommendedProductPrice">
								<div className="RecommendedCoursePrice">{offer_price_display}</div>
								<div className="RecommendedCoursePriceOffer">
									{original_price_display}{' '}
								</div>
								<span className="RecommendedCourseOffer"> {offer_percent}</span>
								<div className="RecommendedCourseTax">Inclusive of Tax</div>
								{isInternational ? (
									<a
										href={`${Config.WEBSITEURL}product/${product_name_slug}`}
										target="_blank"
										rel="noopener noreferrer"
										className="RecommendedCourseButtonBuy"
									>
										Learn More
									</a>
								) : (
									<div
										className="RecommendedCourseButtonBuy"
										onClick={() => learnMoreClick()}
										style={{ cursor: 'pointer' }}
									>
										Learn More
									</div>
								)}
							</div>
						</div>
					</div>
				</Card.Body>
			</Card>
		</Zoom>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		setCurrentProductId: (id) => dispatch(setCurrentProductId(id)),
	};
};

export default withRouter(
	connect(null, mapDispatchToProps)(RecommendedProductCard),
);
